import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { FileText, Zap } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-16 md:pt-24 pb-16 md:pb-24 overflow-hidden" data-id="element-133">
      {/* Background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[500px] bg-brand-green/20 blur-[120px] rounded-full pointer-events-none" data-id="element-134" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-135">
        <div className="max-w-4xl mx-auto text-center" data-id="element-136">
          {/* Brand Name */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="mb-4 md:mb-6 mt-[-61px]" data-id="element-137">
            <span className="inline-flex items-center gap-2 text-brand-light font-bold text-lg sm:text-2xl md:text-3xl tracking-wider font-[Poppins,_sans-serif]" data-id="element-138">
              🌿 BIOMA LÍVIDO™
            </span>
          </motion.div>

          {/* Main Headline — styled like the reference image */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="mb-6 md:mb-10" data-id="element-139">
            <h1 className="font-extrabold leading-[1.05] tracking-tight font-[Poppins,_sans-serif] text-4xl sm:text-5xl md:text-6xl lg:text-7xl" data-id="element-140">
              <span className="block text-white text-[33px]" data-id="element-141">
                Tu cerebro de antes.
              </span>
              <span className="block text-brand-light text-[33px]" data-id="element-142">
                De vuelta. Desde hoy.
              </span>
            </h1>
          </motion.div>

          {/* Product Mockup Image */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.3
        }} className="relative max-w-[16rem] md:max-w-lg mx-auto mb-5 md:mb-12" data-id="element-143">
            <img src="https://cdn.magicpatterns.com/uploads/mnW1M275S3YJK1N6pJgur1/Mockup_-_SN4.png" alt="Código Niebla Cero Mockup" className="w-full h-auto drop-shadow-2xl md:mt-[-35px] md:mb-[-35px] mt-[-30px] mb-[-30px] pt-[10px] pb-[10px]" data-id="element-144" />
          </motion.div>

          {/* Subtitle & Description */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="mb-5 md:mb-7" data-id="element-145">
            <h2 className="text-brand-gold font-bold text-base sm:text-xl md:text-2xl mb-3 md:mb-4 font-[Poppins,_sans-serif]" data-id="element-146">
              CÓDIGO NIEBLA CERO™
            </h2>
            <p className="sm:text-base md:text-lg text-gray-200 px-2 max-w-2xl mx-auto text-[13px]" data-id="element-147">
              El sistema que conecta lo que tu médico nunca unió: tu intestino
              con tu niebla mental, tu fatiga y tus olvidos. Sin antibióticos
              como primer paso. Sin dietas imposibles.
            </p>
          </motion.div>

          {/* Feature Badges */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.5
        }} className="flex flex-wrap justify-center gap-2 md:gap-3 mb-8 md:mb-10 text-xs md:text-sm font-medium text-gray-300 mt-[-3px]" data-id="element-148">
            <div className="flex items-center gap-1.5 md:gap-2 bg-brand-dark px-3 md:px-4 py-1.5 md:py-2 rounded-full border border-gray-700" data-id="element-149">
              <FileText className="w-3.5 h-3.5 md:w-4 md:h-4 text-brand-light" data-id="element-150" />
              100% PDF
            </div>
            <div className="flex items-center gap-1.5 md:gap-2 bg-brand-dark px-3 md:px-4 py-1.5 md:py-2 rounded-full border border-gray-700" data-id="element-151">
              <Zap className="w-3.5 h-3.5 md:w-4 md:h-4 text-brand-gold" data-id="element-152" />
              Acceso en 5 min
            </div>
            <div className="flex items-center gap-1.5 md:gap-2 bg-brand-dark px-3 md:px-4 py-1.5 md:py-2 rounded-full border border-gray-700" data-id="element-153">
              <Zap className="w-3.5 h-3.5 md:w-4 md:h-4 text-brand-light" data-id="element-154" />
              Implementación inmediata
            </div>
          </motion.div>

          {/* CTA Button */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.6
        }} className="flex flex-col items-center" data-id="element-155">
            <Button href="#pricing" showBadges className="text-base md:text-xl py-5 md:py-6 px-6 md:px-10 w-full max-w-lg mb-5 md:mb-6 font-bold" data-id="element-156">
              🧠 QUIERO RECUPERAR MI CLARIDAD MENTAL AHORA
            </Button>
          </motion.div>
        </div>
      </div>
    </section>;
}